import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'

import EnablerWrapper from '../pages/enabler/EnablerWrapper'
import EnablerDetailWrapper from '../pages/enabler/detail/EnablerDetailWrapper'

import MemberWrapper from '../pages/member-management/member/MemberWrapper'
import MemberCreateWrapper from '../pages/member-management/member/create/MemberCreateWrapper'
import MemberDetailWrapper from '../pages/member-management/member/detail/MemberDetailWrapper'
import MemberUpdateWrapper from '../pages/member-management/member/update/MemberUpdateWrapper'

import CustomerStateWrapper from '../pages/member-management/customer-state/CustomerStateWrapper'
import CustomerStateDetailWrapper from '../pages/member-management/customer-state/detail/CustomerStateDetailWrapper'

import PersonaWrapper from '../pages/self-care-plan/persona/PersonaWrapper'
import PersonaCreateWrapper from '../pages/self-care-plan/persona/create/PersonaCreateWrapper'
import PersonaDetailWrapper from '../pages/self-care-plan/persona/detail/PersonaDetailWrapper'
import PersonaUpdateWrapper from '../pages/self-care-plan/persona/update/PersonaUpdateWrapper'

import SelfCareWrapper from '../pages/self-care-plan/self-care/SelfCareWrapper'
import SelfCareDetailWrapper from '../pages/self-care-plan/self-care/detail/SelfCareDetailWrapper'
import SelfCareCreateWrapper from '../pages/self-care-plan/self-care/create/SelfCareCreateWrapper'
import SelfCareUpdateWrapper from '../pages/self-care-plan/self-care/update/SelfCareUpdateWrapper'

import TestimoniWrapper from '../pages/self-care-plan/testimoni/TestimoniWrapper'
import TestimoniDetail from '../pages/self-care-plan/testimoni/detail/TestimoniDetail'

import ProductWrapper from '../pages/loyalty-point/product/ProductWrapper'

import CampaignWrapper from '../pages/loyalty-point/campaign/CampaignWrapper'
import CampaignCreate from '../pages/loyalty-point/campaign/create/CreateCampaign'
import CampaignDetail from '../pages/loyalty-point/campaign/detail/DetailCampaign'
import CampaignUpdate from '../pages/loyalty-point/campaign/update/UpdateCampaign'

import TransactionManagementWrapper from '../pages/loyalty-point/transaction-management/TransactionManagementWrapper'
import RedemptionManagementWrapper from '../pages/loyalty-point/redemption-management/RedemptionManagement'
import ConfigurationWrapper from '../pages/configuration/ConfigurationWrapper'

import DepartmentDetail from '../pages/configuration/department/Detail'
import DepartmentCreate from '../pages/configuration/department/create'
import DepartmentUpdate from '../pages/configuration/department/update'
import DepartmentWrapper from '../pages/configuration/department/DepartmentsWrapper'

import UserPoints from '../pages/loyalty-point/user-point'

import RewardsDetail from '../pages/loyalty-point/rewards-detail/RewardsDetailCatalog'

import ProductDetail from '../pages/loyalty-point/product/detail/ProductDetail'
import ProductCreate from '../pages/loyalty-point/product/create/CreateProduct'
import ProductUpdate from '../pages/loyalty-point/product/update/UpdateProduct'

import RedeemptionsDetail from '../pages/loyalty-point/redemption-management/detail/RedeemptionsDetail'
import RedeemptionsCreate from '../pages/loyalty-point/redemption-management/create/CreateRedemptions'
import RedeemptionsUpdate from '../pages/loyalty-point/redemption-management/update/UpdateRedemptions'

import TransactionsCreate from '../pages/loyalty-point/transaction-management/create/CreateTransactions'
import TransactionsDetail from '../pages/loyalty-point/transaction-management/detail/TransactionsDetail'
import TransactionsUpdate from '../pages/loyalty-point/transaction-management/update/UpdateTransactions'

import RewardsCatalogWrapper from '../pages/loyalty-point/rewards-catalog/RewardsCatalogWrapper'
import RewardsCatalogCreate from '../pages/loyalty-point/rewards-catalog/create/CreateRewards'
import RewardsCatalogUpdate from '../pages/loyalty-point/rewards-catalog/update/UpdateRewardsCatalog'

import RewardsDetailUpdate from '../pages/loyalty-point/rewards-detail/update/UpdateRewardsDetail'
import RewardsDetailCreate from '../pages/loyalty-point/rewards-detail/create/CreateVoucherDetail'

const PrivateRoutes = () => {
  // const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  // const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  // const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />

        <Route path='member-management/member' element={<MemberWrapper />} />
        <Route path='member-management/membercreate' element={<MemberCreateWrapper />} />
        <Route path='member-management/memberdetail/:id' element={<MemberDetailWrapper />} />
        <Route path='member-management/memberupdate/:id' element={<MemberUpdateWrapper />} />

        <Route path='member-management/customer-state' element={<CustomerStateWrapper />} />
        <Route
          path='member-management/customer-state/:id'
          element={<CustomerStateDetailWrapper />}
        />

        <Route path='self-care-plan/persona' element={<PersonaWrapper />} />
        <Route path='self-care-plan/personacreate' element={<PersonaCreateWrapper />} />
        <Route path='self-care-plan/personadetail/:id' element={<PersonaDetailWrapper />} />
        <Route path='self-care-plan/personaupdate/:id' element={<PersonaUpdateWrapper />} />

        <Route path='self-care-plan/self-care' element={<SelfCareWrapper />} />
        <Route path='self-care-plan/self-carecreate' element={<SelfCareCreateWrapper />} />
        <Route path='self-care-plan/self-caredetail/:id' element={<SelfCareDetailWrapper />} />
        <Route path='self-care-plan/self-careupdate/:id' element={<SelfCareUpdateWrapper />} />

        <Route path='self-care-plan/testimoni' element={<TestimoniWrapper />} />
        <Route path='self-care-plan/testimonidetail/:id' element={<TestimoniDetail />} />

        <Route path='loyalty-point/product' element={<ProductWrapper />} />
        <Route path='productdetail/:id' element={<ProductDetail />} />
        <Route path='productcreate' element={<ProductCreate />} />
        <Route path='productupdate/:id' element={<ProductUpdate />} />

        <Route path='loyalty-point/rewards-catalog' element={<RewardsCatalogWrapper />} />

        <Route path='rewards-catalog/create' element={<RewardsCatalogCreate />} />

        <Route path='rewards-catalogupdate/:id' element={<RewardsCatalogUpdate />} />

        <Route path='rewards-catalogdetail/:id' element={<RewardsDetail />} />
        <Route path='rewardsupdate/:id' element={<RewardsDetailUpdate />} />
        <Route path='rewardscreate/:id' element={<RewardsDetailCreate />} />

        <Route path='loyalty-point/campaign' element={<CampaignWrapper />} />
        <Route path='campaigncreate' element={<CampaignCreate />} />
        <Route path='campaigndetail/:id' element={<CampaignDetail />} />
        <Route path='campaignupdate/:id' element={<CampaignUpdate />} />

        <Route
          path='loyalty-point/transaction-management'
          element={<TransactionManagementWrapper />}
        />
        <Route
          path='loyalty-point/redemption-management'
          element={<RedemptionManagementWrapper />}
        />
        <Route
          path='loyalty-point/transaction-management'
          element={<TransactionManagementWrapper />}
        />
        <Route path='transactioncreate' element={<TransactionsCreate />} />
        <Route path='transactiondetail/:id' element={<TransactionsDetail />} />
        <Route path='transactionupdate/:id' element={<TransactionsUpdate />} />

        <Route
          path='loyalty-point/redemption-management'
          element={<RedemptionManagementWrapper />}
        />
        <Route path='loyalty-point/user-point' element={<UserPoints />} />

        <Route path='redemptionsdetail/:id' element={<RedeemptionsDetail />} />
        <Route path='redemptionscreate' element={<RedeemptionsCreate />} />
        <Route path='redemptionsupdate/:id' element={<RedeemptionsUpdate />} />

        <Route path='configuration/point' element={<ConfigurationWrapper />} />

        <Route path='configuration/department' element={<DepartmentWrapper />} />
        <Route path='configuration/departmentcreate' element={<DepartmentCreate />} />
        <Route path='configurationdetail/:id' element={<DepartmentDetail />} />
        <Route path='configurationupdate/:id' element={<DepartmentUpdate />} />

        <Route path='/enabler' element={<EnablerWrapper />} />
        <Route path='/enabler/:id' element={<EnablerDetailWrapper />} />
        {/* Lazy Modules */}
        {/* <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        /> */}
        {/* <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        /> */}
        {/* <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        /> */}
        {/* <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        /> */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const EnablerRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Enabler after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/enabler' />} />
        {/* Pages */}
        <Route path='/enabler' element={<EnablerWrapper />} />
        <Route path='/enabler/:id' element={<EnablerDetailWrapper />} />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes, EnablerRoutes}
